var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4052 25 25 19.4052 25 12.5C25 5.59479 19.4052 0 12.5 0C5.59479 0 0 5.59479 0 12.5C0 19.4052 5.59479 25 12.5 25ZM5.71979 12.2292L17.7719 7.58229C18.3313 7.38021 18.8198 7.71875 18.6385 8.56458L18.6396 8.56354L16.5875 18.2313C16.4354 18.9167 16.0281 19.0833 15.4583 18.7604L12.3333 16.4573L10.826 17.9094C10.6594 18.076 10.5187 18.2167 10.1958 18.2167L10.4177 15.0365L16.2094 9.80417C16.4615 9.58229 16.1531 9.45729 15.8208 9.67813L8.66354 14.1844L5.57812 13.2219C4.90833 13.0094 4.89375 12.5521 5.71979 12.2292Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a7574b7f0488d86cccdabaf0f6a9d0a4.svg";
export { ForwardRef as ReactComponent };